import { i18n } from "../i18n/i18n";

import React, { Component } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import routes from '../routes/routes'
import confirmService from '../services/confirm.service'
import alertService from '../services/alert.service'
import contactApi, {
  ContactableType, ContactCreateRequest
} from '../apis/contact.api'
import { ConfirmParams } from '../components/Confirm/Confirm.state'
import ContentLayout from '../components/ContentLayout'
import ContentMain from '../components/ContentMain'
import Card from '../components/Card'
import CardButton from '../components/CardButton'
import Row from '../components/Row/Row'
import InputText from '../components/InputText'
import PageHeading from '../components/PageHeading'
import RadioGroup, { RadioGroupItem } from '../components/RadioGroup'
import ContactSiteInput, {
  ContactSiteInputSite
} from '../components/ContactSiteInput'

interface ContactCreateProps extends RouteComponentProps {}

interface ContactCreateState {
  sites: ContactSiteInputSite[]
  type: string
  name: string
}

class ContactCreate extends Component<ContactCreateProps, ContactCreateState> {
  types: RadioGroupItem[] = [
    { name: 'customer', label: 'Customer' },
    { name: 'vendor', label: 'Vendor' }
  ]

  constructor (props: ContactCreateProps) {
    super(props)
    this.state = {
      sites: [],
      type: '',
      name: ''
    }
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleTypeChange = this.handleTypeChange.bind(this)
    this.handleSitesChange = this.handleSitesChange.bind(this)
    this.handleCreateClick = this.handleCreateClick.bind(this)
  }

  create () {
    const { type: contactType, name, sites } = this.state
    const payload: ContactCreateRequest = {}
    if (contactType) payload.contact = contactType as ContactableType
    if (name) payload.name = name
    if (sites) payload.sites = sites
    contactApi.create(payload, contact => {
      if (!contact) return
      alertService.success('Successfully created contact')
      this.props.history.push(routes.contacts)
    })
  }

  handleInputChange (name: string, value: string) {
    if (name === 'type') this.setState({ type: value })
    if (name === 'name') this.setState({ name: value })
  }

  handleTypeChange (name: string) {
    this.setState({ type: name })
  }

  handleSitesChange (sites: ContactSiteInputSite[]) {
    this.setState({ sites })
  }

  handleCreateClick () {
    const confirm: ConfirmParams = {
      id: 1,
      question: i18n('Please review the contact details above and then confirm'),
      confirmText: i18n('Confirm'),
      cancelText: i18n('Cancel'),
      onConfirm: () => this.create()
    }
    confirmService.push(confirm)
  }

  render () {
    return (
      <ContentLayout>
        <ContentMain layout="twoThird">
          <Card>
            <PageHeading
              text={i18n("Create Contact")}
              doc='contacts-create-contact' />
            <Row column={2}>
              <RadioGroup
                label={i18n("Contact")}
                radios={this.types}
                checked={this.state.type}
                onChange={this.handleTypeChange} />
              <InputText
                name="name"
                value={this.state.name}
                label={i18n("Contact global name")}
                onChange={this.handleInputChange} />
            </Row>
            <ContactSiteInput
              sitesCreated={this.state.sites}
              onSitesCreatedChange={this.handleSitesChange} />
            <CardButton
              proceedText={i18n("Create")}
              cancelText={i18n("Cancel")}
              onProceedClick={this.handleCreateClick} />
          </Card>
        </ContentMain>
      </ContentLayout>
    )
  }
}

export default withRouter(ContactCreate)
